import { useState, useCallback, useMemo } from 'react';
import { FilterConfiguration } from '../types';
import { getInitialFiltersFromConfig } from '../utils/filterUtils';

/**
 * Dynamic filters hook that generates filter state based on Sitecore configuration
 * No more hardcoded filter fields - everything is driven by the config
 */
export const useFilters = (filterConfig?: FilterConfiguration) => {
  // Generate initial filters dynamically from config
  const initialFilters = useMemo(() => getInitialFiltersFromConfig(filterConfig), [filterConfig]);

  const [filters, setFilters] = useState<Record<string, string>>(initialFilters);

  const handleFilterChange = useCallback((field: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const handleClearFilters = useCallback(() => {
    setFilters(initialFilters);
  }, [initialFilters]);

  const activeFilterCount = Object.values(filters).filter((v) => v !== '').length;

  return {
    filters,
    handleFilterChange,
    handleClearFilters,
    activeFilterCount,
  };
};
